export const publicSitePublicationFlags = {
  aiContextLayerVideo: true,
  learnHub: false,
  guides: false,
  stories: false,
} as const;
